import TestingContainer from './TestingContainer'

export default TestingContainer
